<template>
    <div class="home-step" style="position:relative">
        <!--<b-button class="button is-primary next-button" @click="nextStep()">Quero receber esta oferta</b-button>-->
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";

export default {
    mixins: [mixin],
}
</script>
